export default __webpack_public_path__ + "static/media/to_delete3.7c1a954f.png";